import { render, staticRenderFns } from "./CodeCard.vue?vue&type=template&id=47ce6659&scoped=true&"
import script from "./CodeCard.vue?vue&type=script&lang=ts&"
export * from "./CodeCard.vue?vue&type=script&lang=ts&"
import style0 from "./CodeCard.vue?vue&type=style&index=0&id=47ce6659&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ce6659",
  null
  
)

component.options.__file = "CodeCard.vue"
export default component.exports